import React from 'react'


const Alertas = () => {
  return (
    <div>
      <h1 style={{marginLeft: 300, fontFamily: "Avenir Next"}}>Alertas</h1>
    </div>
  )
}

export default Alertas